<template>
  <div class="admin-email-templates-edit p-4 sm:p-6 lg:p-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Edit Email Template</h1>
        <p class="text-gray-600 mt-1">{{ template.name }}</p>
      </div>
      <Link
        :href="route('admin.email-templates.index')"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
      >
        Back to List
      </Link>
    </div>

    <!-- Form -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
      <form @submit.prevent="submit">
        <div class="space-y-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Template Name</label>
            <p class="text-gray-900">{{ template.name }}</p>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Slug</label>
            <code class="px-3 py-2 bg-gray-100 rounded text-sm">{{ template.slug }}</code>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">HTML Content *</label>
            <textarea
              v-model="form.html"
              required
              rows="15"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 font-mono text-sm"
            ></textarea>
            <p class="text-xs text-gray-500 mt-1">Edit the HTML template. Use variables like {name}, {email}, etc.</p>
          </div>

          <div class="flex items-center gap-4">
            <button
              type="submit"
              :disabled="submitting"
              class="px-6 py-3 bg-green-600 text-white rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-700"
            >
              {{ submitting ? 'Updating...' : 'Update Template' }}
            </button>
            <Link
              :href="route('admin.email-templates.index')"
              class="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold transition-colors hover:bg-gray-300"
            >
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, useForm } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  components: {
    Link,
  },
  props: {
    template: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Edit Email Template',
    },
  },
  data() {
    return {
      form: useForm({
        html: this.template.html || '',
      }),
      submitting: false,
    }
  },
  methods: {
    submit() {
      this.submitting = true
      this.form.put(route('admin.email-templates.update', this.template.id), {
        onSuccess: () => {
          if (window.$toast) {
            window.$toast.success('Template updated successfully')
          }
        },
        onError: () => {
          this.submitting = false
        },
        onFinish: () => {
          this.submitting = false
        },
      })
    },
  },
}
</script>

<style scoped>
.admin-email-templates-edit {
  min-height: 100vh;
  background-color: #f9fafb;
}
</style>



